// // 设置 rem 函数
// function setRem() {
//   // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。
//   const scale = document.documentElement.clientWidth / 1920;
//   console.log("scale:",document.documentElement.clientWidth);
//   // 设置页面根节点字体大小
//   document.documentElement.style.fontSize =baseSize * Math.min(scale, 2) + 'px';
//   console.log(document.documentElement.style.fontSize);
// }
/**
 * 是否pc端
 */
export function isPC_() {
	if(navigator&&navigator.userAgent!=undefined&&/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
		return false;
	} else {
		return true;
	}
}

//rem配置
export default{
    baseSize:100,//基准大小   1rem为100px
    designWidth:1920,//设计宽度
    setRemPC:function(document) {//pc端
      let docEl = document.documentElement;
      let clientWidth = docEl.clientWidth;
      if (clientWidth) {
        let scale=Math.max(clientWidth / this.designWidth,0.5);// 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。最小0.5倍
        docEl.style.fontSize =this.baseSize * scale + "px";//最小缩小5倍
      } else {
        return;
      }
    },
    setRemMobile:function(document) {
      this.baseSize=37.5;//基准大小   1rem为100px
      this.designWidth=750;//设计宽度
      let docEl = document.documentElement;
      let clientWidth = docEl.clientWidth;
      if (clientWidth) {
        let scale=Math.min(clientWidth / this.designWidth,2);// 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。最大2倍
        docEl.style.fontSize =this.baseSize * scale + "px";//最小缩小5倍
      } else {
        return;
      }
    },
    setRem:function(document) {
      if(isPC_){
        this.setRemPC(document);
      }else{
        this.setRemMobile(document);
      }
    },
    initRem(document, window) {
      if (document.addEventListener) {
        this.setRem(document);
      } else {
        return;
      }
      document.addEventListener("ready",()=>{this.setRem(document);}, false);
      window.addEventListener("resize", ()=>{this.setRem(document);}, false);
    },
}